import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import moment from "moment";

import {FilterLeadDataListAPI} from "./../../../API/Publisher/LeadAPI";
//import Sidebar from "./../Common/Sidebar";
//import Header from "./../Common/Header";
//import Loader from "./../../Loader";
import Paginate from "./../../../utils/Pagination";
import Layout from "./../Layout";
import ContentLoader from "../../../utils/ContentLoader";
import "./../../../Public/css/leads_list.css";


const LeadFilter = () =>{

    const {filtertype} = useParams();
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);

    const perpagedata = 20;


    useEffect(() => {

        FilterLeadDataListAPI(setLeads, setLoading, currentPage, perpagedata, setPageCount, filtertype);

    }, [currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }


    return(
    <Layout>
        <div className="content">

            <div className="row">
                <div className="col-md-12">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                {filtertype === 'freshlead' ?
                                <h4 className="page-title">Fresh Leads</h4>
                                :
                                    (filtertype === 'totallead' ?
                                        <h4 className="page-title">Total Leads</h4>
                                    :
                                        <></>
                                    )
                                }
                            </div>
                            <div className="col-4 text-end">

                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="card">

                        <div className="card-body">

                            <div className="table-responsive table-wrapper">
                                {loading ?
                                    <div>
                                        <ContentLoader />
                                    </div>
                                :
                                <table className="table" id="">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Contact</th>
                                            <th>Location</th>
                                            <th>Program</th>
                                            <th>University/Institute</th>
                                            <th>Source</th>
                                            <th>Created Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                    {
                                    leads && leads.length > 0  ?
                                        leads.map(lead =>
                                        (

                                            <tr key={lead.id}>

                                                <td>
                                                    <Link to={`/publisher/lead-profile/${lead.id}`} className="">
                                                    {lead.name}
                                                    </Link>
                                                </td>
                                                <td>{lead.email}</td>
                                                <td>{lead.contact}</td>
                                                <td>{lead.location}</td>
                                                <td>{lead.program}</td>
                                                <td>{lead.institute}</td>
                                                <td>{lead.source}</td>
                                                <td> {moment(lead.created_at).format('DD-MMM-YYYY h:mm')} </td>

                                            </tr>
                                        ))
                                    :

                                        <tr>
                                            <td colSpan="8">
                                                <p>No record found...</p>
                                            </td>
                                        </tr>
                                    }

                                    </tbody>
                                </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    {pagecount > 1 ?
                    <div className="pagination-section mt-3">

                        <nav>
                            <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                        </nav>
                    </div>
                    :
                        <></>
                    }

                </div>
            </div>
        </div>
    </Layout>
    )
}

export default LeadFilter;
